import { gql } from '@apollo/client'

export const CREATE_SUBSCRIPTION_SESSION = gql`
    mutation booking_create_subs_session(
        $lot_id: String!
        $shopper_email: String!
        $shopper_locale: String!
        $start_date: String!
        $top_level_domain: String
        $license_plate_id: String
    ) {
        booking_create_subs_session(
            lot_id: $lot_id
            shopper_email: $shopper_email
            shopper_locale: $shopper_locale
            start_date: $start_date
            top_level_domain: $top_level_domain
            license_plate_id: $license_plate_id
        ) {
            session_data
            session_id
        }
    }
`
